import { LocalStorageHelper } from "../helpers";
import { LocalStorageKeys } from "../constants";
import { useQuery } from "../hooks";
import { IS_UNIVERSAL_PARTNER } from "../constants/host-name";

export const getCurrentLanguageCode = (
  defaultLan = IS_UNIVERSAL_PARTNER ? "sp" : "en",
): string => {
  return LocalStorageHelper.getItem(LocalStorageKeys.Language) || defaultLan;
};
